import { render, staticRenderFns } from "./PProduct.vue?vue&type=template&id=702cf9dc"
import script from "./PProduct.vue?vue&type=script&lang=js"
export * from "./PProduct.vue?vue&type=script&lang=js"
import style0 from "./PProduct.vue?vue&type=style&index=0&id=702cf9dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports